import { render, staticRenderFns } from "./hamcollection.vue?vue&type=template&id=06b82547&scoped=true&"
import script from "./hamcollection.vue?vue&type=script&lang=ts&"
export * from "./hamcollection.vue?vue&type=script&lang=ts&"
import style0 from "./hamcollection.vue?vue&type=style&index=0&id=06b82547&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b82547",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostSubtitle: require('/tmp/build_b2fe7c28/components/blog/BlogPostSubtitle.vue').default,BlogPostTextBlock: require('/tmp/build_b2fe7c28/components/blog/BlogPostTextBlock.vue').default,BlogPostCitation: require('/tmp/build_b2fe7c28/components/blog/BlogPostCitation.vue').default,BlogPostImage: require('/tmp/build_b2fe7c28/components/blog/BlogPostImage.vue').default})
